export default val => {
    if (!val) {
        return 'UN';
    }

    val = val.replace(/[^a-zA-Z0-9\s]/g, '');

    const [firstPiece, secondPiece] = val.split(' ');

    return `${firstPiece?.[0] || ''}${secondPiece?.[0] || ''}`.toUpperCase();
};
